import React from 'react'
import useOfferionTranslation from '../../store/hooks/useOfferionTranslation'

export function CountryLabel({ country }: { country?: string }) {
    const { t } = useOfferionTranslation()

    if (!country) {
        return null
    }

    return <span>{t(`Allaround.Country.${country}`)}</span>
}
